import { takeEvery, put, call } from "redux-saga/effects";
import { ADD_SHIFT, CANCEL_SHIFT_ADMIN, DELETE_SHIFT, GET_SHIFTS, SHIFT_LOGS, SHIFT_REPORT, UPDATE_SHIFT } from "./actionTypes";
import {
  addShiftFail,
  addShiftSuccess,
  cancelShiftFail,
  cancelShiftSuccess,
  deleteShiftFail,
  deleteShiftSuccess,
  getShiftsFail,
  getShiftsSuccess,
  shiftLogsFail,
  shiftLogsSuccess,
  shiftReportFail,
  shiftReportSuccess,
  updateShiftFail,
  updateShiftSuccess,
} from "./action";
import { AddShift, fetchShifts, shiftUpdate, shiftDelete, onGettingShiftLogs, onGettingShiftReport, onCancellingShift } from "helpers/fakebackend_helper";

import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Shift Roster";

function* onGet({ payload: data }) {
  try {
    const response = yield call(fetchShifts, data);
    yield put(getShiftsSuccess(response));
  } catch (error) {
    yield put(getShiftsFail(error));
    showToast("error", "Shift", error);
  }
}

function* onLogs({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingShiftLogs, data);
    yield call(responseHandler, toastTitle, response, shiftLogsSuccess, shiftLogsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getShiftsFail(error));
    showToast("error", "Shift", error);
  }
}

function* onUpdate({ payload: data }) {
  try {
    const response = yield call(shiftUpdate, data);
    if (response?.status) {
      yield put(updateShiftSuccess(response));
      showToast("success", "Shift", response.message);
    } else {
      yield put(updateShiftFail(response));
      showToast("warning", "Shift", response.message);
    }
  } catch (error) {
    yield put(updateShiftFail(error));
    showToast("error", "Shift", error);
  }
}

function* onAdd({ payload: data }) {
  try {
    const response = yield call(AddShift, data);
    if (response?.status) {
      yield put(addShiftSuccess(response));
      showToast("success", "Shift", response.message);
    } else {
      yield put(addShiftFail({ ...(response && { response }), ignore: true }));
      showToast("warning", "Shift", response.message, 15000);
    }
  } catch (error) {
    yield put(addShiftFail(error));
    showToast("error", "Shift", error);
  }
}

function* onDelete({ payload: data }) {
  try {
    const response = yield call(shiftDelete, data);
    if (response?.status) {
      yield put(deleteShiftSuccess(response));
      showToast("success", "Shift", response.message);
    } else {
      yield put(deleteShiftFail(response));
      showToast("warning", "Shift", response.message);
    }
  } catch (error) {
    yield put(deleteShiftFail(error));
    showToast("error", "Shift", error);
  }
}

function* onReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingShiftReport, data);
    yield call(responseHandler, "Shift", response, shiftReportSuccess, shiftReportFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(shiftReportFail(error));
    showToast("error", "Shift", error);
  }
}

function* onCancelShift({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onCancellingShift, data);
    yield call(responseHandler, "Shift", response, cancelShiftSuccess, cancelShiftFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(shiftReportFail(error));
  }
}

export function* ShiftSaga() {
  yield takeEvery(ADD_SHIFT, onAdd);
  yield takeEvery(GET_SHIFTS, onGet);
  yield takeEvery(SHIFT_LOGS, onLogs);
  yield takeEvery(UPDATE_SHIFT, onUpdate);
  yield takeEvery(DELETE_SHIFT, onDelete);
  yield takeEvery(SHIFT_REPORT, onReport);
  yield takeEvery(CANCEL_SHIFT_ADMIN, onCancelShift);
}

export default ShiftSaga;
